import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

i18n
  .use(HttpBackend) // load translations from public/locales
  .use(LanguageDetector) // detect user language
  .use(initReactI18next) // pass i18n instance to react-i18next

export const initPromise = i18n
  .init({
    fallbackLng: 'en',
    debug: false,
    ns: ['translation'], // Specify namespaces
    defaultNS: 'translation', // Default namespace
    supportedLngs: ['en', 'ja'], // Supported languages
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    react: {
      useSuspense: false, // Disable suspense to avoid loading issues
    },
  })
  .catch((error) => {
    console.error('[i18n] Initialization error:', error)
  })

export default i18n
